import React, { useEffect, useState } from "react";

import "./CustomerServiceModal.css";
import { getCustomerBookedServicesAPI } from "../../../../utils/APIs/customerApis";

const CustomerServiceModal = ({ isOpen, customer, onClose }) => {

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);


  console.log("CUSTOMER...", customer)

  // const fetchServices = async () => {
  //   if (!customer?.id) return;

  //   setLoading(true);

  //   try {
  //     const res = await getCustomerBookedServicesAPI(customer.id);
  //     setServices(res?.data?.data || []);
  //   } catch (error) {
  //     console.error("Failed to fetch services:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   if (isOpen && customer?.id) {
  //     fetchServices();
  //   }
  // }, [isOpen]);

  useEffect(() => {
  if (!isOpen || !customer?.id) return;

  const fetchServices = async () => {
    setLoading(true);

    try {
      const res = await getCustomerBookedServicesAPI(customer.id);
      setServices(res?.data?.data || []);
    } catch (error) {
      console.error("Failed to fetch services:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchServices();
}, [isOpen, customer?.id]);



  if (!isOpen) return null; // 👈 THIS prevents it from showing

  return (
    <div className="customer-modal-overlay">
      <div className="customer-modal-container">
        <div className="customer-modal-header">
          {/* <h3>{customer.name}'s Booked Services</h3> */}
          <h3>
            {customer?.name === "-"
              ? "Booked Services"
              : `${customer.name}'s Booked Services`}
          </h3>
          <button className="close-btn" onClick={onClose}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {loading ? (
            <p>Loading...</p>
          ) : services.length === 0 ? (
            <p>No services found.</p>
          ) : (
            <table className="services-table">
              <thead>
                <tr>
                  <th>Service Name</th>
                  {/* <th>Date</th> */}
                  <th>Status</th>
                  {/* <th>Amount</th> */}
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={index}>
                    <td>{service.serviceName}</td>
                    {/* <td>{service.date}</td> */}
                    <td>{service.status}</td>
                    {/* <td>{service.amount}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerServiceModal;